
// AssistantWelcomeCard.js
import React from 'react';
import { Card, CardBody } from 'reactstrap';
import AssistantProfileSpeaking from 'components/assistant/AssistantProfileSpeaking';
import { useTranslation } from 'react-i18next';

function AssistantWelcomeCard({welcomeMsg}) {
    const { t } = useTranslation();
    return (
        <Card className="card-customer" style={{ backgroundColor: "#e14eca" }}>
            <CardBody>
                <AssistantProfileSpeaking />
                <div className="alert alert-info mt-3" role="alert">
                    {t(welcomeMsg)}
                </div>
            </CardBody>
        </Card>
    );
}

export default AssistantWelcomeCard;
